<template>
  <div class="block">
    <template v-if="templateView">
      <InformationLayout :showHeader="false" :sections="sections" />
    </template>
    <div v-else class="flex flex-col gap-6 w-full">
      <div class="flex items-center justify-start">
        <div
          class="text-foreground text-lg font-semibold leading-6 line-clamp-1"
        >
          {{ t("Основные параметры") }}
        </div>
      </div>

      <div class="flex flex-col gap-8">
        <div class="flex flex-col gap-5">
          <div class="text-muted-foreground text-sm font-medium leading-5">
            {{ t("Наименование") }}
          </div>
          <form class="w-full flex flex-col gap-2">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <FormField name="category_code">
                <FormItem float>
                  <FormLabel>{{
                    t("Категория нотариального действия (рус)")
                  }}</FormLabel>
                  <FormControl>
                    <Popover v-model:open="categoryPopoverOpen">
                      <PopoverTrigger as-child>
                        <div
                          class="flex w-full items-center gap-2 rounded-md border border-input bg-transparent px-3 h-9 cursor-pointer text-foreground"
                          :data-filled="
                            formValues.category_code ? '' : undefined
                          "
                        >
                          <span
                            v-if="formValues.category_code"
                            class="flex-1 text-sm leading-none truncate"
                          >
                            {{ selectedCategoryName }}
                          </span>
                          <span
                            v-else
                            class="flex-1 text-sm leading-none text-muted-foreground"
                          />
                          <button
                            v-if="formValues.category_code"
                            type="button"
                            class="shrink-0 rounded-sm opacity-50 hover:opacity-100"
                            @click.stop.prevent="changeCategory('')"
                          >
                            <X class="size-3.5" />
                          </button>
                          <ChevronDown class="size-4 shrink-0 opacity-50" />
                        </div>
                      </PopoverTrigger>
                      <PopoverContent
                        class="w-[var(--reka-popover-trigger-width)] p-0"
                        align="start"
                      >
                        <div class="flex items-center gap-2 border-b px-3 h-9">
                          <SearchIcon
                            class="size-4 shrink-0 text-muted-foreground"
                          />
                          <input
                            v-model="categorySearch"
                            :placeholder="t('Поиск...')"
                            class="flex-1 bg-transparent text-sm outline-none placeholder:text-muted-foreground"
                          />
                        </div>
                        <div class="max-h-60 overflow-y-auto p-1">
                          <div
                            v-if="!filteredCategories.length"
                            class="py-6 text-center text-sm text-muted-foreground"
                          >
                            {{ t("Ничего не найдено") }}
                          </div>
                          <button
                            v-for="item in filteredCategories"
                            :key="item.code"
                            type="button"
                            :class="[
                              'flex w-full items-center justify-between rounded-sm px-2.5 py-2.5 text-sm text-left cursor-pointer hover:bg-accent hover:text-accent-foreground',
                              item.code === formValues.category_code &&
                                'bg-accent text-accent-foreground',
                            ]"
                            @click="
                              changeCategory(item.code);
                              categoryPopoverOpen = false;
                              categorySearch = '';
                            "
                          >
                            <span class="flex-1 text-sm leading-5">{{
                              item.name
                            }}</span>
                            <Check
                              v-if="item.code === formValues.category_code"
                              class="size-4 shrink-0"
                            />
                          </button>
                        </div>
                      </PopoverContent>
                    </Popover>
                  </FormControl>
                </FormItem>
              </FormField>

              <FormField name="category_code">
                <FormItem float>
                  <FormLabel>{{
                    t("Категория нотариального действия (қаз)")
                  }}</FormLabel>
                  <FormControl>
                    <Popover v-model:open="categoryKzPopoverOpen">
                      <PopoverTrigger as-child>
                        <div
                          class="flex w-full items-center gap-2 rounded-md border border-input bg-transparent px-3 h-9 cursor-pointer text-foreground"
                          :data-filled="
                            formValues.category_code ? '' : undefined
                          "
                        >
                          <span
                            v-if="formValues.category_code"
                            class="flex-1 text-sm leading-none truncate"
                          >
                            {{ selectedCategoryNameKz }}
                          </span>
                          <span
                            v-else
                            class="flex-1 text-sm leading-none text-muted-foreground"
                          />
                          <button
                            v-if="formValues.category_code"
                            type="button"
                            class="shrink-0 rounded-sm opacity-50 hover:opacity-100"
                            @click.stop.prevent="changeCategory('')"
                          >
                            <X class="size-3.5" />
                          </button>
                          <ChevronDown class="size-4 shrink-0 opacity-50" />
                        </div>
                      </PopoverTrigger>
                      <PopoverContent
                        class="w-[var(--reka-popover-trigger-width)] p-0"
                        align="start"
                      >
                        <div class="flex items-center gap-2 border-b px-3 h-9">
                          <SearchIcon
                            class="size-4 shrink-0 text-muted-foreground"
                          />
                          <input
                            v-model="categorySearch"
                            :placeholder="t('Поиск...')"
                            class="flex-1 bg-transparent text-sm outline-none placeholder:text-muted-foreground"
                          />
                        </div>
                        <div class="max-h-60 overflow-y-auto p-1">
                          <div
                            v-if="!filteredCategories.length"
                            class="py-6 text-center text-sm text-muted-foreground"
                          >
                            {{ t("Ничего не найдено") }}
                          </div>
                          <button
                            v-for="item in filteredCategories"
                            :key="item.code"
                            type="button"
                            :class="[
                              'flex w-full items-center justify-between rounded-sm px-2.5 py-2.5 text-sm text-left cursor-pointer hover:bg-accent hover:text-accent-foreground',
                              item.code === formValues.category_code &&
                                'bg-accent text-accent-foreground',
                            ]"
                            @click="
                              changeCategory(item.code);
                              categoryKzPopoverOpen = false;
                              categorySearch = '';
                            "
                          >
                            <span class="flex-1 text-sm leading-5">{{
                              item.name_kz
                            }}</span>
                            <Check
                              v-if="item.code === formValues.category_code"
                              class="size-4 shrink-0"
                            />
                          </button>
                        </div>
                      </PopoverContent>
                    </Popover>
                  </FormControl>
                </FormItem>
              </FormField>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <FormField name="code">
                <FormItem float>
                  <FormLabel>{{ t("Нотариальное действие (рус)") }}</FormLabel>
                  <FormControl>
                    <Popover v-model:open="actionPopoverOpen">
                      <PopoverTrigger as-child>
                        <div
                          class="flex w-full items-center gap-2 rounded-md border border-input bg-transparent px-3 h-9 cursor-pointer text-foreground"
                          :data-filled="formValues.code ? '' : undefined"
                        >
                          <span
                            v-if="formValues.code"
                            class="flex-1 text-sm leading-none truncate"
                          >
                            {{ selectedActionName }}
                          </span>
                          <span
                            v-else
                            class="flex-1 text-sm leading-none text-muted-foreground"
                          />
                          <button
                            v-if="formValues.code"
                            type="button"
                            class="shrink-0 rounded-sm opacity-50 hover:opacity-100"
                            @click.stop.prevent="changeNotaryAction('')"
                          >
                            <X class="size-3.5" />
                          </button>
                          <ChevronDown class="size-4 shrink-0 opacity-50" />
                        </div>
                      </PopoverTrigger>
                      <PopoverContent
                        class="w-[var(--reka-popover-trigger-width)] p-0"
                        align="start"
                      >
                        <div class="flex items-center gap-2 border-b px-3 h-9">
                          <SearchIcon
                            class="size-4 shrink-0 text-muted-foreground"
                          />
                          <input
                            v-model="actionSearch"
                            :placeholder="t('Поиск...')"
                            class="flex-1 bg-transparent text-sm outline-none placeholder:text-muted-foreground"
                          />
                        </div>
                        <div class="max-h-60 overflow-y-auto p-1">
                          <div
                            v-if="!filteredActions.length"
                            class="py-6 text-center text-sm text-muted-foreground"
                          >
                            {{ t("Ничего не найдено") }}
                          </div>
                          <button
                            v-for="item in filteredActions"
                            :key="item.code"
                            type="button"
                            :class="[
                              'flex w-full items-center justify-between rounded-sm px-2.5 py-2.5 text-sm text-left cursor-pointer hover:bg-accent hover:text-accent-foreground',
                              item.code === formValues.code &&
                                'bg-accent text-accent-foreground',
                            ]"
                            @click="
                              changeNotaryAction(item.code);
                              actionPopoverOpen = false;
                              actionSearch = '';
                            "
                          >
                            <span class="flex-1 text-sm leading-5">{{
                              item.name
                            }}</span>
                            <Check
                              v-if="item.code === formValues.code"
                              class="size-4 shrink-0"
                            />
                          </button>
                        </div>
                      </PopoverContent>
                    </Popover>
                  </FormControl>
                </FormItem>
              </FormField>

              <FormField name="code">
                <FormItem float>
                  <FormLabel>{{ t("Нотариальное действие (қаз)") }}</FormLabel>
                  <FormControl>
                    <Popover v-model:open="actionKzPopoverOpen">
                      <PopoverTrigger as-child>
                        <div
                          class="flex w-full items-center gap-2 rounded-md border border-input bg-transparent px-3 h-9 cursor-pointer text-foreground"
                          :data-filled="formValues.code ? '' : undefined"
                        >
                          <span
                            v-if="formValues.code"
                            class="flex-1 text-sm leading-none truncate"
                          >
                            {{ selectedActionNameKz }}
                          </span>
                          <span
                            v-else
                            class="flex-1 text-sm leading-none text-muted-foreground"
                          />
                          <button
                            v-if="formValues.code"
                            type="button"
                            class="shrink-0 rounded-sm opacity-50 hover:opacity-100"
                            @click.stop.prevent="changeNotaryAction('')"
                          >
                            <X class="size-3.5" />
                          </button>
                          <ChevronDown class="size-4 shrink-0 opacity-50" />
                        </div>
                      </PopoverTrigger>
                      <PopoverContent
                        class="w-[var(--reka-popover-trigger-width)] p-0"
                        align="start"
                      >
                        <div class="flex items-center gap-2 border-b px-3 h-9">
                          <SearchIcon
                            class="size-4 shrink-0 text-muted-foreground"
                          />
                          <input
                            v-model="actionSearch"
                            :placeholder="t('Поиск...')"
                            class="flex-1 bg-transparent text-sm outline-none placeholder:text-muted-foreground"
                          />
                        </div>
                        <div class="max-h-60 overflow-y-auto p-1">
                          <div
                            v-if="!filteredActions.length"
                            class="py-6 text-center text-sm text-muted-foreground"
                          >
                            {{ t("Ничего не найдено") }}
                          </div>
                          <button
                            v-for="item in filteredActions"
                            :key="item.code"
                            type="button"
                            :class="[
                              'flex w-full items-center justify-between rounded-sm px-2.5 py-2.5 text-sm text-left cursor-pointer hover:bg-accent hover:text-accent-foreground',
                              item.code === formValues.code &&
                                'bg-accent text-accent-foreground',
                            ]"
                            @click="
                              changeNotaryAction(item.code);
                              actionKzPopoverOpen = false;
                              actionSearch = '';
                            "
                          >
                            <span class="flex-1 text-sm leading-5">{{
                              item.name_kz
                            }}</span>
                            <Check
                              v-if="item.code === formValues.code"
                              class="size-4 shrink-0"
                            />
                          </button>
                        </div>
                      </PopoverContent>
                    </Popover>
                  </FormControl>
                </FormItem>
              </FormField>
            </div>
          </form>
        </div>

        <!-- Языки шаблонов -->
        <div class="w-full overflow-hidden rounded-md border border-border">
          <div class="bg-muted/30 px-5 py-3 border-b border-border">
            <div class="text-sm font-medium text-foreground">
              {{ t("Языки шаблонов") }}
            </div>
          </div>
          <div class="flex gap-6 flex-wrap px-5 py-4">
            <div
              v-for="lang in languages"
              :key="lang.code"
              class="flex items-center gap-2 cursor-pointer select-none"
            >
              <Switch
                :model-value="form?.languages.includes(lang.code)"
                @change="toggle(lang.code)"
                size="medium"
              />
              <div class="text-foreground text-sm font-medium leading-5">
                {{ t(lang.label) }}
              </div>
            </div>
          </div>
        </div>

        <!-- Дата окончания -->
        <div class="w-full overflow-hidden rounded-md border border-border">
          <div
            class="flex items-center gap-2 bg-muted/30 px-5 py-3"
            :class="{ 'border-b border-border': form.show_end_date }"
          >
            <Switch
              :model-value="form.show_end_date"
              @change="form.show_end_date = !form.show_end_date"
              size="medium"
            />
            <div class="text-sm font-medium text-foreground">
              {{ t("Показывать дату окончания") }}
            </div>
          </div>

          <div v-if="form.show_end_date" class="px-5 py-4">
            <div class="flex flex-wrap items-center gap-x-6 gap-y-2.5">
              <label
                v-for="unit in endDateUnits"
                :key="unit.code"
                class="flex items-center gap-2 cursor-pointer select-none text-foreground text-sm font-medium leading-5"
              >
                <Checkbox
                  :checked="(form.end_date_units || []).includes(unit.code)"
                  @update:checked="toggleEndDateUnit(unit.code)"
                />
                {{ t(unit.label) }}
              </label>
            </div>
          </div>
        </div>

        <!-- Ключ-заменитель участника -->
        <div class="w-full overflow-hidden rounded-md border border-border">
          <div class="bg-muted/30 px-5 py-3 border-b border-border">
            <div class="text-sm font-medium text-foreground">
              {{ t("Шаблон повторяемых участников") }}
            </div>
          </div>
          <form class="w-full flex flex-col gap-2 px-5 py-4">
            <FormField name="default_participant_code">
              <FormItem float class="!mb-0">
                <FormLabel>{{ t("Ключ-заменитель участника") }}</FormLabel>
                <Input
                  v-model="form.default_participant_code"
                  class="w-1/2"
                  :placeholder="
                    t(
                      'Например: nas. В нотариальном действии заменяется на реальный код участника'
                    )
                  "
                />
              </FormItem>
            </FormField>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as z from "zod";
import InformationLayout from "@/shared/ui/information-layout/InformationLayout.vue";
import {
  getDirectoryItem,
  getDirectoryItemsByCodes,
} from "@/entities/directory";
import { Switch } from "@/shared/ui/switch";
import { Checkbox } from "@/shared/ui/checkbox";
import { FormField, FormItem, FormLabel, FormControl } from "@/shared/ui/form";
import { Popover, PopoverTrigger, PopoverContent } from "@/shared/ui/popover";
import { Search as SearchIcon, X, ChevronDown, Check } from "lucide-vue-next";
import { Input } from "@/shared/ui/input";
import { END_DATE_UNITS } from "@/shared/lib/constants";

const route = useRoute();
const { t } = useI18n();

const props = defineProps({
  form: {
    type: Object,
    default: () => ({}),
  },
});

// vee-validate setup
const schema = toTypedSchema(
  z.object({
    category_code: z.string().min(1, ""),
    code: z.string().min(1, ""),
  })
);

const {
  validate: veeValidate,
  setFieldValue,
  values: formValues,
} = useForm({
  validationSchema: schema,
  initialValues: {
    category_code: props.form.category_code || "",
    code: props.form.code || "",
  },
});

// data
const category = ref(null);
const notary_action = ref(null);
const languages = [
  { code: "ru", label: "Русский" },
  { code: "kz", label: "Казахский" },
  { code: "en", label: "Английский" },
];
const endDateUnits = END_DATE_UNITS;
const actionLabels = reactive({});
const categorySearch = ref("");
const categoryPopoverOpen = ref(false);
const categoryKzPopoverOpen = ref(false);
const actionSearch = ref("");
const actionPopoverOpen = ref(false);
const actionKzPopoverOpen = ref(false);

// computed
const filteredCategories = computed(() => {
  const items = category.value?.children || [];
  if (!categorySearch.value) return items;
  const q = categorySearch.value.toLowerCase();
  return items.filter(
    (item) =>
      (item.name || "").toLowerCase().includes(q) ||
      (item.name_kz || "").toLowerCase().includes(q)
  );
});

const filteredActions = computed(() => {
  const items = notary_action.value?.children || [];
  if (!actionSearch.value) return items;
  const q = actionSearch.value.toLowerCase();
  return items.filter(
    (item) =>
      (item.name || "").toLowerCase().includes(q) ||
      (item.name_kz || "").toLowerCase().includes(q)
  );
});

const selectedCategoryName = computed(() => {
  if (!formValues.category_code) return "";
  const found = (category.value?.children || []).find(
    (c) => c.code === formValues.category_code
  );
  return found?.name || formValues.category_code;
});

const selectedCategoryNameKz = computed(() => {
  if (!formValues.category_code) return "";
  const found = (category.value?.children || []).find(
    (c) => c.code === formValues.category_code
  );
  return found?.name_kz || formValues.category_code;
});

const selectedActionName = computed(() => {
  if (!formValues.code) return "";
  const found = (notary_action.value?.children || []).find(
    (c) => c.code === formValues.code
  );
  return found?.name || formValues.code;
});

const selectedActionNameKz = computed(() => {
  if (!formValues.code) return "";
  const found = (notary_action.value?.children || []).find(
    (c) => c.code === formValues.code
  );
  return found?.name_kz || formValues.code;
});

const templateView = computed(() => {
  return route.name === "constructor_action_item_view";
});

const sections = computed(() => {
  if (!props.form) return [];
  return [
    {
      title: t("Основные параметры"),
      items: [
        {
          label: t("Категория нотариального действия"),
          values: [
            {
              lang: t("Рус"),
              text: getActionLabel(props.form.category_code),
            },
            {
              lang: t("Қаз"),
              text: getActionLabel(props.form.category_code, "name_kz"),
            },
          ],
        },
        {
          label: t("Нотариальное действие"),
          values: [
            { lang: t("Рус"), text: getActionLabel(props.form?.code) },
            {
              lang: t("Қаз"),
              text: getActionLabel(props.form?.code, "name_kz"),
            },
          ],
        },
        {
          label: t("Языки шаблонов"),
          values: [
            {
              text: props.form.languages?.length
                ? getLangTitle(props.form.languages)
                : t("Не указано"),
            },
          ],
        },
        {
          label: t("Показывать дату окончания"),
          values: [{ text: props.form.show_end_date ? t("Да") : t("Нет") }],
        },
        ...(props.form.show_end_date
          ? [
              {
                label: t("Доступные единицы срока"),
                values: [
                  {
                    text: props.form.end_date_units?.length
                      ? getEndDateUnitsTitle(props.form.end_date_units)
                      : t("Не указано"),
                  },
                ],
              },
            ]
          : []),
      ],
    },
  ];
});

// watchers
watch(
  () => props.form.category_code,
  (newVal) => {
    if (newVal && newVal !== formValues.category_code) {
      setFieldValue("category_code", newVal);
      getTemplateCategoryChildren(newVal);
      getActionLabelsForItems([newVal]);
    }
  }
);

console.log("constructor main");

watch(
  () => props.form.code,
  (newVal) => {
    if (newVal && newVal !== formValues.code) {
      setFieldValue("code", newVal);
      getActionLabelsForItems([newVal]);
    }
  }
);

watch(
  () => formValues.category_code,
  (newVal) => {
    if (props.form.category_code !== (newVal || null)) {
      props.form.category_code = newVal || null;
    }
  }
);

watch(
  () => formValues.code,
  (newVal) => {
    if (props.form.code !== (newVal || null)) {
      props.form.code = newVal || null;
    }
  }
);

// methods
async function getTemplateCategories() {
  try {
    const data = await getDirectoryItem("notarial_action_category");

    if (data?.success && data.payload) {
      category.value = data.payload;
    }
  } catch (error) {
    console.error("Ошибка загрузки деталей:", error);
  }
}

async function getTemplateCategoryChildren(code) {
  try {
    const data = await getDirectoryItem(code);
    if (data?.success && data.payload) {
      notary_action.value = data.payload;
    }
  } catch (error) {
    console.error("Ошибка загрузки деталей:", error);
  }
}

async function getActionLabelsForItems(items) {
  const codes = [...new Set(items.map((item) => item))].filter(
    (code) => !actionLabels[code]
  );

  if (!codes.length) return;

  const { success, payload } = await getDirectoryItemsByCodes({ codes });

  if (success && payload?.items?.length) {
    payload.items.forEach((item) => {
      actionLabels[item.code] = {
        name: item.name || item.code,
        name_kz: item.name_kz || item.code,
      };
    });
  }
}

function getActionLabel(code, lang = "name") {
  return actionLabels[code]?.[lang] || code;
}

function toggle(code) {
  if (props.form.languages.includes(code)) {
    props.form.languages = props.form.languages.filter((c) => c !== code);
  } else {
    props.form.languages.push(code);
  }
}

function toggleEndDateUnit(code) {
  const current = Array.isArray(props.form.end_date_units)
    ? props.form.end_date_units
    : [];
  if (current.includes(code)) {
    props.form.end_date_units = current.filter((c) => c !== code);
  } else {
    props.form.end_date_units = [...current, code];
  }
}

async function validate() {
  const result = await veeValidate();
  return result.valid;
}

function getLangTitle(langs) {
  return langs
    .map((l) => languages.find((lang) => lang.code === l)?.label || l)
    .join(", ");
}

function getEndDateUnitsTitle(units) {
  return units
    .map((u) => {
      const found = endDateUnits.find((unit) => unit.code === u);
      return found ? t(found.label) : u;
    })
    .join(", ");
}

function changeCategory(category_code) {
  setFieldValue("category_code", category_code || "");
  setFieldValue("code", "");
  props.form.category_code = category_code || null;
  props.form.code = null;
  notary_action.value = null;
  if (category_code) {
    getTemplateCategoryChildren(category_code);
  }
}

function changeNotaryAction(code) {
  setFieldValue("code", code || "");
  props.form.code = code || null;
}

// mounted
onMounted(async () => {
  await getTemplateCategories();

  const codesToFetch = [props.form.category_code, props.form.code].filter(
    Boolean
  );
  if (codesToFetch.length) {
    await getActionLabelsForItems(codesToFetch);
  }

  if (props.form.category_code) {
    setFieldValue("category_code", props.form.category_code);
    await getTemplateCategoryChildren(props.form.category_code);
  }
  if (props.form.code) {
    setFieldValue("code", props.form.code);
  }
});

defineExpose({ validate });
</script>

<style lang="scss" scoped>
.block {
  @apply h-full overflow-auto rounded-2xl p-8 w-1/2;
  background-color: hsl(var(--background));
}

@media (max-width: 1500px) {
  .block {
    @apply w-full;
  }
}
</style>
